import React from "react";

import WhoWeAreImage from "../Assets/who-we-are.png";

import Arrow from "../Assets/Arrow.png";

const WhoWeAre = ({ hideOnMobile }) => {
  return (
    <>
      <section
        className={hideOnMobile ? "d-none d-lg-block" : ""}
        id="section6"
      >
        <div className="who_we_are" id="who-we-are">
          <div className="who_we_are_bg">
            <div className="who_we_are_container">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="left">
                      <div className="fig position-relative">
                        <div className="ripple">
                          <div className="ring1">
                            <div className="dot">
                              <div className="dot-circle"></div>
                            </div>
                          </div>
                          <div className="ring2">
                            <div className="dot">
                              <div className="dot-circle"></div>
                            </div>
                          </div>
                          <div className="fig-circle">
                            <img src={WhoWeAreImage} width={250} alt="" />
                          </div>
                        </div>
                        <div className="arrow-img">
                          <img src={Arrow} width={200} alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="right">
                      <div className="heading">
                        <h3>
                          Who <span>We Are</span>?
                        </h3>
                        {/* <p>
                          We are experts in creating engaging, effective, and
                          interactive eLearning content for industries
                          worldwide, with a proven track record in the aviation
                          sector
                        </p> */}
                        <p>We specialize in designing engaging and interactive e-Learning content for industries worldwide. Our expertise is well-established in the aviation sector, where we’ve developed solutions trusted by leading organizations.</p>
                        <p>Beyond aviation, we’ve also delivered impactful training for healthcare, hospitality, maritime, and oil & gas clients—successfully creating more than 50 modules tailored to diverse needs.</p>
                      </div>

                      {/* <div className="stats">
                        <div className="stats-box">
                          <span className="count">10+</span>
                          <span>Projects Completed</span>
                        </div>
                        <div className="stats-box">
                          <span className="count">100+</span>
                          <span>Satisfied Clients</span>
                        </div>
                      </div> */}

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WhoWeAre;
